export default "__VITE_ASSET__A_$fTcB4__"